// extracted by mini-css-extract-plugin
export default {"text-body-1":"MyButton_text-body-1__oTqcf","text-body-3":"MyButton_text-body-3__B3rr4","myButton":"MyButton_myButton__sX8Jc","upDown":"MyButton_upDown__1q1-u"};